import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useObject } from 'react-firebase-hooks/database'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, useHistory, useLocation, useParams } from 'react-router'
import { toast } from 'react-toastify'
import BackToHomeButton from 'src/components/BackToHomeButton'
import { fixedAssets } from 'src/containers/PreCache'
import { getLiveSession } from 'src/ducks/liveSession'
import routes from 'src/routes'
import Amplitude from 'src/utils/amplitudeHelper'
import styled from 'styled-components'
import LoadIcon from '../components/LoadIcon'
import config from '../config'
import { getLiveSessionDb } from '../firebaseConfig'
import { SIZES } from '../styles/theme'
import { useAutoMute } from '../utils/useAutoMute'

const Page = styled.div`
  background: #000;

  header {
    background-image: url(${fixedAssets.top});
    background-position: center top;
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3rem 3rem;
    position: sticky;
    z-index: 10;
  }
  .viewer-container {
    position: relative;
    width: 100%;
    min-height: 500px;
    /* 48px+48px + 120px = 216px */
    height: calc(100vh - 230px);
  }
  .content {
    position: absolute;
    padding: 0 1rem;
    margin: 0 auto;
    margin-bottom: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  ${SIZES.mobile} {
    padding-bottom: 3rem;
    .viewer-container {
      height: 0;
      padding-bottom: 58.5%;
      min-height: 0;
    }
    .content {
      width: 100%;
      height: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50.5%, -51%);
    }
  }
`

export default function AuditoriumPage({ currentUser }) {
  useAutoMute()
  const history = useHistory()
  const { sessionId } = useParams()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [watchPlayBack, setWatchPlayBack] = useState(useLocation()?.search === '?playback')
  const { session } = useSelector((state) => state.liveSession)
  const [snapshot, snapshotLoading, snapshotError] = useObject(getLiveSessionDb(sessionId))

  useEffect(() => {
    document.title = `${config.eventName} | Auditorium`
  }, [])

  useEffect(() => {
    if (!snapshotLoading && !snapshotError) {
      if (!snapshot.val() && currentUser.role !== 'superadmin') {
        toast('The admin has closed this hall.', { toastId: 'sessionError' })
        history.push(routes.lobby)
      } else {
        dispatch(getLiveSession(sessionId))
        Amplitude.visit("Auditorium")
        Amplitude.watchPlayback(sessionId)
      }
    }
  }, [snapshotLoading, snapshot, history, currentUser.id, sessionId, dispatch])


  if (isEmpty(session)) {
    return <LoadIcon />
  }
  if (!session?.hasAccess && currentUser.role !== 'superadmin') {
    toast("You don't have access to the session.", { toastId: 'accessError' })
    return <Redirect to={routes.lobby} />
  }
  const liveStreamComponent = (
    <>
      {session?.streamUrl ? (
        <div className="content">
          {loading && <LoadIcon />}
          <iframe
            title="Live Broadcast"
            src={`${session.streamUrl}?autoplay=1`}
            allow="autoplay; fullscreen"
            allowFullScreen
            frameBorder="0"
            onLoad={() => {
              setLoading(false)
            }}
          />
        </div>
      ) : (
        <div className="content">
          <div className="noStreamUrl">No stream URL for this session</div>
        </div>
      )}
    </>
  )

  const playbackComponent = (
    <>
      {session?.playbackUrl ? (
        <div className="content">
          {loading && <LoadIcon />}
          <iframe
            title="Live Broadcast"
            src={`${session.playbackUrl}?autoplay=1`}
            allow="autoplay; fullscreen"
            allowFullScreen
            frameBorder="0"
            onLoad={() => {
              setLoading(false)
            }}
          />
        </div>
      ) : (
        <div className="content">
          <div className="noStreamUrl">No playbackUrl URL for this session</div>
        </div>
      )}
    </>
  )
  return (
    <Page>
      <header></header>
      <Row noGutters>
        <Col xs={{ span: 12 }} md={{ span: 12 }} className="viewer-container">
          {watchPlayBack ? playbackComponent : liveStreamComponent}
        </Col>
        {/* <Col xs={{ span: 12 }} md={{ span: 4 }} className="mx-auto mt-0 my-md-5 pb-5 pb-md-0">
          <iframe 
            src="https://app.sli.do/event/x42avThM7o5akSZYy7xs8j" 
            height="100%" 
            width="100%" 
            frameBorder="0" 
            style={{ minHeight: "600px" }} 
            title="Slido"
          ></iframe>
      
        </Col> */}
      </Row>
    </Page>
  )
}
